export const regex = {
  name: /^\w{5,20}$/,
  pwd: /^[\w|\W]{6,16}$/,
  realName: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/,
  email: /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/,
  mobile: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
  mobileSecret: /(\d{3})\d{4}(\d{4})/,
  phone: /^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/,
  phoneAndMobile: /^((0[0-9]{2,3}-?)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?)|(1[3|4|5|6|7|8|9][0-9]\d{8})$/,
  verifyCode: /^\d{6}\b/,
  postCode: /^[1-9][0-9]{5}$/,
  input100: /^[\u4e00-\u9fa5a-zA-Z0-9-,]{1,100}$/,
  licensePlateNum: /^[\u4e00-\u9fa5][A-Za-z][0-9A-Za-z]{5,6}$/,
  licenseNum: /^[A-Za-z][0-9A-Za-z]{5,6}$/,
  frameNum: /^[0-9a-zA-Z]{17}$/,
  engineNo: /^[0-9a-zA-Z-]{6,20}$/,
  seatNum: /^[1-9][0-9]{0,2}$/,
  number: /^\d{1,10}$/,
  floatNumber: /^\d{1,10}.?\d{0,2}$/,
  accountNum: /^[1-9]{1}(\d{15}|\d{18})$/,
  corpNumber: /^[0-9A-Z]{18}$/,

  password1: /^(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/ // 长度至少8位，必含大小写字母
}



// WEBPACK FOOTER //
// ./src/utils/regex.js